import { useEffect, useState } from "react";
import { LOCAL_STORAGE_NAMES } from "const";
import { MediaConstraints } from "types";

export default function useMediaConstraints(defaultConstraints: MediaConstraints) {
  const [mediaConstraints, setMediaConstraints] = useState<MediaConstraints>(() => {
    const storageConstraints = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAMES.MEDIA_CONSTRAINTS) ?? "{}");

    // If defaults explicitly disable video (e.g. voiceOnly), don't restore from storage
    const videoExplicitlyDisabled = defaultConstraints.videoEnabled === false;

    return {
      video: storageConstraints.video ?? defaultConstraints.video ?? false,
      audio: storageConstraints.audio ?? defaultConstraints.audio ?? false,
      videoEnabled: videoExplicitlyDisabled ? false : (storageConstraints.videoEnabled ?? defaultConstraints.videoEnabled ?? false),
      audioEnabled: storageConstraints.audioEnabled ?? defaultConstraints.audioEnabled ?? false,
      shareEnabled: defaultConstraints.shareEnabled ?? false,
      blurEnabled: false, // Never auto-restore blur — heavy WASM load, user must enable explicitly
    };
  });

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_NAMES.MEDIA_CONSTRAINTS, JSON.stringify(mediaConstraints));
  }, [mediaConstraints]);

  return {
    mediaConstraints,
    setMediaConstraints,
  };
}
